import { Box, Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'

export const MetadataViewer = ({ metadata }) => {
  const { t } = useTranslation(['common'])

  if (!metadata || Object.keys(metadata).length === 0) {
    return (
      <Paper elevation={0} className={styles.container}>
        <Typography variant="h5">{t('common:metadata')}</Typography>
        <Typography variant="body2" color="textSecondary">
          {t('common:noData')}
        </Typography>
      </Paper>
    )
  }

  return (
    <Paper elevation={0} className={styles.container}>
      <Typography variant="h5" mb={2}>
        {t('common:metadata')}
      </Typography>
      <Box className={styles.jsonContainer}>
        <pre>{JSON.stringify(metadata, null, 2)}</pre>
      </Box>
    </Paper>
  )
}
